import { Reveal } from "./shared";
import { IMAGES } from "../data/content";

const ANNOTATIONS = [
    { label: "TRANSMISSION", pos: "top-[14%] left-[6%]" },
    { label: "FIELD EXECUTION", pos: "top-[42%] right-[5%]" },
    { label: "INFRASTRUCTURE", pos: "bottom-[12%] left-[10%]" },
];

export const Transmission = () => (
    <section data-testid="transmission-section" className="relative bg-vec-charcoal text-white py-16 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 tech-grid-dark opacity-50" aria-hidden="true" />
        <div className="relative vec-container">
            <div className="grid grid-cols-12 gap-y-10 lg:gap-x-14 items-center">
                <div className="col-span-12 lg:col-span-5">
                    <Reveal>
                        <div className="flex items-center gap-3 font-mono-tech text-[11px] sm:text-xs uppercase tracking-[0.22em] text-vec-green-bright">
                            <span className="text-white/40">SEC 03</span>
                            <span className="h-px w-10 bg-vec-green-bright/60" aria-hidden="true" />
                            <span>Flagship — Power Transmission</span>
                        </div>
                    </Reveal>
                    <Reveal delay={0.08}>
                        <h2 className="mt-5 font-display text-[clamp(1.5rem,1rem+1.8vw,3.1rem)] font-semibold tracking-tight leading-[1.1] uppercase text-balance">
                            Building the Network Behind Reliable Power
                        </h2>
                    </Reveal>
                    <Reveal delay={0.16}>
                        <p className="mt-6 text-base sm:text-lg leading-relaxed text-white/70">
                            Transmission towers, conductors and lines form the backbone of the grid.
                            VEC executes tower erection, transmission line construction and ongoing
                            line &amp; tower maintenance — engineered carefully, delivered in the field.
                        </p>
                    </Reveal>
                    <Reveal delay={0.24}>
                        <ul className="mt-8 space-y-0 border-t border-white/10">
                            {["Tower erection & stringing support", "Transmission line construction", "Line & tower maintenance", "Associated civil & structural works"].map((item, i) => (
                                <li
                                    key={item}
                                    className="flex items-center gap-4 py-4 border-b border-white/10 group"
                                >
                                    <span className="font-mono-tech text-[10px] text-vec-green-bright">0{i + 1}</span>
                                    <span className="text-sm sm:text-base text-white/85 group-hover:text-white transition-colors duration-300">
                                        {item}
                                    </span>
                                    <span className="ml-auto h-px flex-1 max-w-16 bg-white/10 group-hover:bg-vec-green-bright/60 transition-colors duration-500" aria-hidden="true" />
                                </li>
                            ))}
                        </ul>
                    </Reveal>
                </div>

                <div className="col-span-12 lg:col-span-7">
                    <Reveal delay={0.1}>
                        <div className="group tech-frame relative overflow-hidden border border-white/15 aspect-[4/3] lg:aspect-[16/11]">
                            <img
                                src={IMAGES.transmissionLarge}
                                alt="High-voltage transmission towers and lines at dusk"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                            <div className="absolute inset-0 bg-vec-charcoal/20" aria-hidden="true" />
                            {ANNOTATIONS.map((a) => (
                                <span
                                    key={a.label}
                                    className={`absolute ${a.pos} hidden sm:flex items-center gap-2 font-mono-tech text-[9px] uppercase tracking-[0.24em] text-white/90 bg-vec-charcoal/70 backdrop-blur-sm px-2 py-1`}
                                >
                                    <span className="h-1.5 w-1.5 rotate-45 bg-vec-green-bright" aria-hidden="true" />
                                    {a.label}
                                </span>
                            ))}
                            <span className="absolute bottom-3 right-3 font-mono-tech text-[9px] uppercase tracking-[0.2em] text-white/60">
                                Fig. 02 — Transmission Network
                            </span>
                        </div>
                    </Reveal>
                </div>
            </div>
        </div>
    </section>
);
